import React, { useEffect } from 'react';
import { Box, BoxProps, Flex, Heading, HeadingProps } from '@chakra-ui/react';
import { ResultProps } from '../../../type';
import Plate from '../atom/Plate';
import DomeCover from '../atom/DomeCover';
import { motion, useAnimation } from 'framer-motion';

const MotionBox = motion<BoxProps>(Box);
const MotionHeading = motion<HeadingProps>(Heading);

// eslint-disable-next-line react/prop-types
const MenuResult: React.FC<ResultProps> = ({ food }: ResultProps) => {
  const headingControls = useAnimation();
  const domeControls = useAnimation();
  useEffect(() => {
    headingControls.set({
      opacity: 0,
    });
    domeControls.set({
      marginBottom: '-6.5em',
      marginTop: 0,
      opacity: 1,
    });
    headingControls.start({
      opacity: 1,
      transition: { duration: 2 },
    });
    domeControls.start({
      marginBottom: 0,
      marginTop: '-6.5em',
      opacity: 0,
      transition: { duration: 2 },
    });
  }, [food]);
  return (
    <Flex align={'center'} justify={'center'} direction={'column-reverse'} mt={8} mb={5}>
      <Plate width={'13em'} height={'4em'} mt={3} />
      <MotionHeading
        size={'lg'}
        initial={{
          opacity: 0,
        }}
        animate={headingControls}
      >
        {food.name}
      </MotionHeading>
      <MotionBox
        initial={{
          marginBottom: '-6.5em',
          marginTop: 0,
          opacity: 1,
        }}
        animate={domeControls}
      >
        <DomeCover ml='0.2em' width={'12.5em'} height={'9em'} />
      </MotionBox>
    </Flex>
  );
};

export default MenuResult;
